import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
    userData: null,
    langId: '1',
    langName: 'English'
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setUserData(state, action) {
            state.userData = action.payload
        },
        setLanguageId(state, action) {
            state.langId = action.payload
        },
        setLanguageName(state, action) {
            state.langName = action.payload
        },
    }
});

export const { setUserData, setLanguageId, setLanguageName } = authSlice.actions;

export default authSlice.reducer;